import "core-js/stable";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "core-js/es/map";
import "core-js/es/set";
import "raf/polyfill";
import ReactDOM from "react-dom";
import { AuthProvider } from "./lib/contexts/AuthContext";
import { MessagesProvider } from "./lib/contexts/MessagesContext";
import App from "./App";

const rootElement = document.getElementById("root");

ReactDOM.render(
  <>
    <MessagesProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </MessagesProvider>
  </>,
  rootElement,
);

navigator.serviceWorker.getRegistrations().then(function (registrations) {
  for (let registration of registrations) {
    registration.unregister();
  }
});
